
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GuitarsPage = lazy(() => import('../pages/guitars/page'));
const CustomPreorderPage = lazy(() => import('../pages/custom-preorder/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/guitars',
    element: <GuitarsPage />,
  },
  {
    path: '/custom-preorder',
    element: <CustomPreorderPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
